module.exports = __webpack_public_path__ + "img/qiye.ab01786d.png";